import { BaseFilterParams } from 'dashboard/lib/interfaces/BaseFilterParams';
import { UserSession, UserSessionAttributes } from 'dashboard/models/user-session';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';

export interface UserSessionsFilterParams extends BaseFilterParams {
  userIds?: string[];
  status?: UserSessionAttributes['status'];
}

export type UserSessionsActions =
  | Action<UserSessionsActionType.SetUserSessions, SetUserSessionsPayload>
  | Action<UserSessionsActionType.SetFilters, SetFiltersPayload>
  | Action<UserSessionsActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<UserSessionsActionType.SetPageSize, SetPageSizePayload>;

export enum UserSessionsActionType {
  SetUserSessions = 'user-sessions/SET_USER_SESSIONS',
  SetFilters = 'user-sessions/SET_FILTERS',
  SetCurrentPage = 'user-sessions/SET_CURRENT_PAGE',
  SetPageSize = 'user-sessions/SET_PAGE_SIZE',
}

interface SetUserSessionsPayload {
  userSessions: UserSession[];
  paginationParams: PaginationParams;
}

export function setUserSessions(userSessions: UserSession[], paginationParams: PaginationParams) {
  return {
    payload: {
      userSessions,
      paginationParams,
    },
    type: UserSessionsActionType.SetUserSessions,
  };
}

interface SetFiltersPayload {
  filters: UserSessionsFilterParams;
}

export function setFilters(filters: UserSessionsFilterParams) {
  return {
    payload: {
      filters,
    },
    type: UserSessionsActionType.SetFilters,
  };
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: UserSessionsActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: UserSessionsActionType.SetPageSize,
  };
}
